module.exports = __webpack_public_path__ + "static/media/swap_white.a9cb6031.svg";